import http from '~/common/http'
export default {
    // 成交订单分析统计
    getPayOrderCount(params, action) {
        return http.get('/api/order-count/' + action, {
            params: params
        });
    },
    // 成交订单分析统计
    getGoalCount(params, action) {
        return http.get('/api/user-count/' + action, {
            params: params
        });
    },

    // 销售排行榜
    getRanking(params) {
        return http.get('/api/order-count/ranking', {
            params: params
        });
    },

    // 数据简报
    getBriefing(params) {
        return http.get('/api/order-count/briefing', {
            params: params
        });
    },

    // 业务员跟进情况
    getTraces(params) {
        return http.get('/api/order-count/traces', {
            params: params
        });
    },

    // 成交客户地区分布
    getAreaMap(params) {
        return http.get('/api/order-count/area-map', {
            params: params
        });
    },

    // 成交客户地区分布
    getAreaList(params) {
        return http.get('/api/order-count/area-list', {
            params: params
        });
    },

    // 客户产品分布
    getCustomerProduct(params) {
        return http.get('/api/order-count/customer-product', {
            params: params
        });
    },

    // 客户等级分布
    getCustomerLevel(params) {
        return http.get('/api/order-count/customer-level', {
            params: params
        });
    },

    // 客户销售漏斗
    getCustomerSale(params) {
        return http.get('/api/order-count/customer-sale', {
            params: params
        });
    },

    // 使用效率分析
    getCustomerRatio(params) {
        return http.get('/api/order-count/customer-ratio', {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/OrderCount.js